import React from 'react'
import { Why1 } from '../imgs/imgs';
import Repeated from './Repeated';
import { Element } from 'react-scroll';

const Why = () => {
  
  return (
    <Element name="why">
    <Repeated imgName={Why1} flexType='flex-col-reverse md:flex-row' bg='bg-slate-50' title='Why we exist' description="At Allo Moniteur, we believe in our fundamental purpose: to empower individuals with the essential skill of safe driving while making a positive impact on society. We recognize that access to quality driving education is not just about mastering the mechanics of operating a vehicle; it's about fostering responsible and confident drivers who contribute to safer roads and communities..."/>
    </Element>
  )
}

export default Why
